import React from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { useEffect, useState } from 'react';
import { Card, List, Modal } from 'antd';
import { programsApi } from '@/api';
import { useTranslation } from 'react-i18next'; // Added import
const { Meta } = Card;

const ProgramModalComponent = ({
    open,
    handleToggleModal,
    handleSelectProgram,
    selectedProgram
}) => {
    const { t } = useTranslation(); // Added hook
    const [data, setData] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(true);
    const [selected, setSelected] = useState(selectedProgram);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 6,
        total: 0
    });
    const getList = () => {
        programsApi
            .getList({
                page: pagination.page,
                pageSize: pagination.pageSize
            })
            .then((res) => {
                setIsLoadingData(false);
                setData(res.data.data.rows);
                setPagination({ ...pagination, total: res.data.data.total });
            })
            .catch((err) => console.error(err));
    };
    useEffect(() => {
        getList();
    }, [pagination.page]);

    return (
        <Modal
            open={open}
            title={t('ProgramModal_Title')} // Added title
            onCancel={handleToggleModal}
            closable={false}
            onOk={() => {
                handleToggleModal();
                handleSelectProgram(selected);
            }}
            okText={t('ProgramModal_Button_Ok')} // Added okText
            cancelText={t('ProgramModal_Button_Cancel')} // Added cancelText
            okButtonProps={{ disabled: !selected }}>
            <List
                grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 2,
                    md: 4,
                    lg: 4,
                    xl: 6,
                    xxl: 2
                }}
                loading={isLoadingData}
                pagination={{
                    pageSize: pagination.pageSize,
                    current: pagination.page,
                    total: pagination.total,
                    onChange: (e) => setPagination({ ...pagination, page: e })
                }}
                dataSource={data}
                renderItem={(item) => (
                    <List.Item>
                        <Card
                            className={`cursor-pointer ${
                                selected?.id === item?.id ? 'border-1 border-red-500' : ''
                            }`}
                            // title={item.title} // Removed this as Meta is used
                            onClick={() => setSelected(item)}>
                            <Meta title={`${item?.name}`} />
                        </Card>
                    </List.Item>
                )}
            />
        </Modal>
    );
};

ProgramModalComponent.displayName = 'ProgramModal';

const ProgramModal = (props) => {
    return (
        <ErrorWrapper>
            <ProgramModalComponent
                data-id="ProgramModal-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default ProgramModal;
